import { HUB_CHANNEL_TYPE_QUERY_PARAM, HUB_TAB_QUERY_PARAM } from "@/dashboard/lib/hub/tab";
import { HubTab } from "@/dashboard/types/hub";

export const DASHBOARD_ROUTES = {
  ANALYTICS: "/dashboard/analytics",
  ANALYTICS_INBOUND: "/dashboard/analytics/inbound",
  ANALYTICS_CAMPAIGNS: "/dashboard/analytics/campaigns",
  ANALYTICS_EXPLORER: "/dashboard/analytics/explorer",
  CALL_SCORING: "/dashboard/call-scoring",
  CALL_SCORING_REVIEW: "/dashboard/call-scoring/review",
  CAPACITY: "/dashboard/capacity",
  DASHBOARD: "/dashboard",
  EMERGENCY: "/dashboard/emergency",
  EMERGENCY_CASES: "/dashboard/emergency/cases",
  EMERGENCY_MANAGE: "/dashboard/emergency/manage",
  HUB_ALL: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.ALL}`,
  HUB_FLAGGED: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.FLAGGED}`,
  HUB_NEW_CUSTOMER: "/dashboard/hub/new-customer",
  HUB_RESOLVED: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.RESOLVED}`,
  HUB_TRANSFERRED: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.TRANSFERRED}`,
  HUB: `/dashboard/hub`,
  MARKETING: "/dashboard/marketing",
  MARKETING_CAMPAIGNS: "/dashboard/marketing/campaigns",
  MARKETING_CAMPAIGNS_CREATE: "/dashboard/marketing/campaigns/create",
  MARKETING_CAMPAIGNS_BUILDER: "/dashboard/marketing/campaigns/create/builder",
  MARKETING_EVENT_TRIGGERS_CREATE: "/dashboard/marketing/event-triggers/create",
  SETTINGS: "/dashboard/settings",
  SETTINGS_TRANSFERS: "/dashboard/settings/transfers",
  SETTINGS_HOURS: "/dashboard/settings/hours",
  SETTINGS_HOLIDAY: "/dashboard/settings/holiday",
  SETTINGS_MEMBERS: "/dashboard/settings/members",
  SETTINGS_CAPACITY_PLANNING: "/dashboard/settings/capacity-planning",
  SETTINGS_EXPORT_REPORTS: "/dashboard/settings/export-reports",
  CALL_RUBRICS: "/dashboard/call-rubrics",
  REPORT_LOG: "/dashboard/report-log",
  MEMBERS: "/dashboard/members",
  SIGN_IN: "/sign-in",
  SWITCH_TENANT: "/dashboard/switch-tenant",
} as const;

export const DYNAMIC_DASHBOARD_ROUTES = {
  CALL_SCORING_USER: (userId: string) =>
    `${DASHBOARD_ROUTES.CALL_SCORING}/user/${userId}`,
  CALL_RUBRIC: (rubricId: string) => `${DASHBOARD_ROUTES.CALL_RUBRICS}/${rubricId}`,
  HUB: (tab: HubTab) => `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${tab}`,
  HUB_CUSTOMER: (customerId: string, tab?: HubTab, channelType?: "messages" | "calls") => {
    const params = new URLSearchParams();
    if (tab) {
      params.set(HUB_TAB_QUERY_PARAM, tab);
    }
    if (channelType) {
      params.set(HUB_CHANNEL_TYPE_QUERY_PARAM, channelType);
    }

    const queryString = params.toString();
    return `/dashboard/hub/${customerId}${queryString ? `?${queryString}` : ""}`;
  },
  MARKETING_CAMPAIGN: (campaignId: string) =>
    `${DASHBOARD_ROUTES.MARKETING_CAMPAIGNS}/${campaignId}`,
} as const;

export const MULTI_TENANT_VIEW_ROUTE_WHITELIST = [DASHBOARD_ROUTES.HUB];
